import { Controller } from "@hotwired/stimulus";
import { createCredential } from "../lib/webauthn";

// Drives passkey registration from account settings. The button's data-action
// calls enroll; on success we reload so the new passkey appears in the list.
export default class extends Controller {
  static values = { optionsUrl: String, createUrl: String };

  async enroll() {
    if (!window.PublicKeyCredential) {
      return;
    }

    const nickname = prompt("Name this passkey", "My passkey");
    if (nickname === null) {
      return;
    }

    try {
      const optionsResponse = await fetch(this.optionsUrlValue, {
        headers: { Accept: "application/json" },
      });
      if (!optionsResponse.ok) {
        return;
      }
      const options = await optionsResponse.json();
      const credential = await createCredential(options);

      const response = await fetch(this.createUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": this.csrfToken,
        },
        body: JSON.stringify({ credential, nickname }),
      });

      if (response.ok) {
        window.location.reload();
      }
    } catch (error) {
      // User cancelled the gesture or the authenticator failed — leave the
      // page as-is; nothing was registered.
    }
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content;
  }
}
